import { ReactNode } from 'react'

export interface IOption {
  label: string
  value: string | number | null
  group?: string
  disabled?: boolean
  alternativeLabel?: ReactNode
  parentId?: string | number
}

export type OptionDependency =
  | IOption[]
  | IOption
  | IOption['value']
  | undefined

export function iOptionEqualityComparer(a: IOption, b: IOption) {
  return a.value == b.value
}

export function isIOption(o: any): o is IOption {
  return (
    (!!o.label && !!o.value && o.value === null) ||
    typeof o.value === 'string' ||
    typeof o.value === 'number'
  )
}

export function isIOptionArray(o: any): o is IOption[] {
  return Array.isArray(o)
}

export function optionDependencyToNumber(option: OptionDependency): number {
  if (!!option) {
    if (isIOption(option)) {
      const { value } = option
      if (value === null) return -1
      return Number(value)
    } else {
      return Number(option)
    }
  }
  return -1
}

export function optionDependencyToArray(option: OptionDependency): IOption[] {
  if (!!option) {
    if (isIOptionArray(option)) {
      return [...option]
    }
  }
  return []
}
